export default __webpack_public_path__ + "static/media/lightSensor.195a26a7.svg";